module.exports = __webpack_public_path__ + "img/html5.9d7db7c9.png";